import React, { useState } from 'react';
import { View, Text } from 'react-native'
import { DateTime } from 'luxon';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from 'app/src/components/Reports';

const WIPReconcile = () => {
  const [endOn, setEndOn] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'wip-reconcile',
      params: { 'end-on': endOn },
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>WIP Fee Reconciliation</Text>
      <Text style={styles.label}>Unsold As Of Date: (optional)</Text>
      <input
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
        type="date"
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default WIPReconcile;
